import base from '../dr-base'
import drRadiobuttons from './dr-radiobuttons.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-radiobuttons',
  name: 'Radio buttons',
  group: 'Input widgets',
  icon: 'check-circle',
  ...base,
  properties: {
    ...base.properties,
    Disabled: {
      name: 'vuetifyWidgets.dr-radiobuttons.disabled',
      type: 'string',
      default: ''
    },
    Caption: {
      name: 'vuetifyWidgets.dr-radiobuttons.caption',
      type: 'string',
      default: ''
    },
    Value: {
      name: 'vuetifyWidgets.dr-radiobuttons.value',
      type: 'string',
      default: '',
      hint: 'vuetifyWidgets.dr-radiobuttons.hint',
      component: 'dr-value-editor'
    },
    Items: {
      name: 'vuetifyWidgets.dr-radiobuttons.items',
      type: 'string',
      default: '',
      hint: 'vuetifyWidgets.dr-radiobuttons.hint',
      component: 'dr-value-editor'
    },
    GenerationOnChange: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-radiobuttons.generationOnChange'
    }
  }
}

export default {
  schema,
  component: drRadiobuttons,
  propEditors: [
    {
      name: 'dr-prop-action'
    }
  ]
}
